import React from "react";
import {Card} from "antd";
import {connect} from "react-redux";
import ListForm from "./ListForm";
import {createContactList} from "../../../actions/contactlists";
import {currentEffectiveUserId} from "../../../reducers/ui";

export const ListNew = props => {
  const { onSubmit, onCancel } = props;
  return <Card
    title={<h1 className={'nomargins'}>Contact List Details</h1>}
    className={'edit-view'}
  >
    <ListForm onCancel={onCancel} onSubmit={onSubmit(props.userId)}/>
  </Card>;
};

export default connect(
  (state, props) => ({userId: currentEffectiveUserId(state)}),
  (dispatch, props) => ({
    onSubmit: userId => list => {
      dispatch(createContactList(list.name, list.description,
        (listId) => props.history.push(`/settings/contact-lists/${listId}`)
      ));
      props.history.goBack();
    },
    onCancel: () => props.history.goBack(),
  }),
)(ListNew);



// WEBPACK FOOTER //
// ./src/components/Settings/ContactLists/ListNew.js